module.exports = __webpack_public_path__ + "img/7.c3e8e4cb.png";